/// <amd-module name="Search/WorkItem/Flux/Sources/CountSpy" />
import { ActionsHub } from "Search/WorkItem/Flux/ActionsHub";
import { EntityTypeUrlParam } from "Search/WorkItem/Constants";
import { IResultsLoadedPayload, IPageInitializedWithSeedDataPayload } from "Search/Shared/Base/ActionsHub";
import { WorkItemSearchResponse, WorkItemResult } from "Search/LegacyWebApi/Contracts/WorkItem";
import { PivotResults } from "Search/Shared/Base/Types";
import { RelationFromExactCount } from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";

export class CountSpy {
    constructor(
        private readonly resultsCount: PivotResults,
        private readonly actionsHub: ActionsHub) {
        this.registerActionsHubHandlers();
    }

    public dispose = (): void => {
        this.disposeActionsHubHandlers();
    }

    private registerActionsHubHandlers = (): void => {
        this.actionsHub.resultsLoaded.addListener(this.resultsLoadedHandler);
        this.actionsHub.pageInitializedWithSeedData.addListener(this.pageInitializedHandler);
    }

    private disposeActionsHubHandlers = (): void => {
        this.actionsHub.resultsLoaded.removeListener(this.resultsLoadedHandler);
        this.actionsHub.pageInitializedWithSeedData.removeListener(this.pageInitializedHandler);
    }

    private resultsLoadedHandler = ({ response }: IResultsLoadedPayload<WorkItemSearchResponse, WorkItemResult>): void => {
        this.onResultsLoaded(response);
    }

    private pageInitializedHandler = ({ response }: IPageInitializedWithSeedDataPayload<WorkItemSearchResponse>): void => {
        this.onResultsLoaded(response);
    }

    private onResultsLoaded = (response?: WorkItemSearchResponse): void => {
        setTimeout(() => {
            if (response) {
                this.resultsCount[EntityTypeUrlParam].value = { count: response.results.count, relationFromExactCount: RelationFromExactCount.Equals };
            }
        }, 0);
    }
}
